import { useApi } from "../useApi";
import { isErr } from "../../Utils/Result";
import { ContractStatus } from "../../Types-DTOs/Contracts";

export const useContracts = () => {
  const {
    listContractsEndpoint,
    getContractEndpoint,
    createContractEndpoint,
    updateContractVariablesEndpoint,
    updateContractMetadataEndpoint,
    exportContractDocxEndpoint,
    listContractTemplatesEndpoint,
  } = useApi();

  const listContracts = async (filters?: { includeArchived?: boolean }) => {
    return await listContractsEndpoint(filters);
  };

  const getContract = async (contractId: string) => {
    return await getContractEndpoint(contractId);
  };

  const createContract = async (data: { templateId: string; title: string }) => {
    return await createContractEndpoint(data);
  };

  const updateVariables = async (contractId: string, variables: Record<string, string>) => {
    return await updateContractVariablesEndpoint(contractId, variables);
  };

  const updateContractMetadata = async (
    contractId: string,
    data: { title?: string; status?: ContractStatus }
  ) => {
    return await updateContractMetadataEndpoint(contractId, data);
  };

  const listContractTemplates = async () => {
    return await listContractTemplatesEndpoint();
  };

  const downloadDocx = async (contractId: string, filename: string) => {
    const result = await exportContractDocxEndpoint(contractId);
    if (!isErr(result)) {
      const url = URL.createObjectURL(result.value);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      a.click();
      URL.revokeObjectURL(url);
    }
    return result;
  };

  return {
    listContracts,
    getContract,
    createContract,
    updateVariables,
    updateContractMetadata,
    listContractTemplates,
    downloadDocx,
  };
};
